import { Component, inject, OnInit } from '@angular/core';
import { InvoiceService } from '../../../../Services/Invoice/invoice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-invoice-b2b',
  standalone: true,
  imports: [NgFor, DecimalPipe, NgIf],
  templateUrl: './invoice-b2b.component.html',
  styleUrls: ['./invoice-b2b.component.css'],
})
export class InvoiceB2bComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  invoiceId!: string;
  isLoading: boolean = false;
  invoiceData: any;
  totalAmount = 0;
  itemsTotalWeight = 0;
  itemsTotalAmount = 0;
  itemsTotalFineWeight = 0;
  amountWithSilver = 0;

  constructor(private invoiceService: InvoiceService) {}

  ngOnInit(): void {
    this.invoiceId = this.route.snapshot.paramMap.get('id')!;
    this.getSingleInvoiceData(this.invoiceId);
  }

  getSingleInvoiceData(id: string): void {
    this.isLoading = true;
    this.invoiceService.getInvoice(id).subscribe({
      next: (response: any) => {
        if (!response || !response.id) {
          console.error('API returned invalid invoice data.', response);
          return;
        }

        this.invoiceData = response;

        // Total Invoice Amount
        this.totalAmount =
          Number(this.invoiceData?.taxable_amount || 0) +
          Number(this.invoiceData?.cgst || 0) +
          Number(this.invoiceData?.sgst || 0);
        this.totalAmount = Number(this.totalAmount.toFixed(2));

        // Items Total Weight
        this.itemsTotalWeight = this.invoiceData?.items?.reduce(
          (sum: number, item: any) =>
            sum + Number(item.stout_total_wt || item.stout_net_weight || 0),
          0
        );
        this.itemsTotalWeight = Number(this.itemsTotalWeight.toFixed(2));

        // Items Total Amount
        this.itemsTotalAmount = this.invoiceData?.items?.reduce(
          (sum: number, item: any) =>
            sum + Number(item.stout_final_amount || 0),
          0
        );
        this.itemsTotalAmount = Number(this.itemsTotalAmount.toFixed(2));

        // Items Total net Weight
        this.itemsTotalFineWeight = this.invoiceData?.items?.reduce(
          (sum: number, item: any) => sum + Number(item.stout_fine_weight || 0),
          0
        );
        this.itemsTotalFineWeight = Number(
          this.itemsTotalFineWeight.toFixed(2)
        );

        // Items Total With Silver
        this.amountWithSilver = this.invoiceData?.items?.reduce(
          (sum: number, item: any) =>
            sum + Number(item.stout_total_amount || 0),
          0
        );
        this.amountWithSilver = Number(this.amountWithSilver.toFixed(2));
        this.isLoading = false;
      },
      error: (err) => {
        console.error('FAILED TO LOAD INVOICE DATA:', err);
        this.isLoading = false;
      },
    });
  }

  printInvoice() {
    const printContents = document.getElementById('print-section')?.innerHTML;
    if (printContents) {
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // layout restore karne ke liye
    }
  }

  roughEstimate() {
    this.router.navigate([`rough-estimate-invoice/${this.invoiceId}`]);
  }
}
